<template>
  <v-col
    v-if="!isHidden"
    class="pa-0"
    :cols="isImageUrl && index > 0 ? '4' : '12'"
    :class="{ 'pa-1': isImageUrl && index > 0 }"
  >
    <template v-if="isImageUrl">
      <v-dialog v-model="dialog" width="500">
        <template v-slot:activator="{ on: OnClick }">
          <v-img
            v-on="{ ...OnClick }"
            :src="firstLink"
            class="card-content-image"
            position="top center"
            style="cursor: pointer;"
          ></v-img>
        </template>

        <v-card>
          <v-img v-ripple :src="firstLink" position="top center"></v-img>
        </v-card>
      </v-dialog>
    </template>
    <template v-else>
      <div
        v-html="page.title"
        class="card-paragraph py-1"
        :class="{ 'text-truncate': firstLink, quote: isQuote }"
      ></div>
    </template>
  </v-col>
</template>

<script>
import { pagesModule } from '@/store/database/pagesModule';
import { computed, ref, watch } from '@vue/composition-api';

export default {
  props: ['note', 'index'],
  setup(props) {
    const page = computed(() => pagesModule.doc(props.note.pageId).data);
    // computed(() => {
    //   const { pages } = usePages();
    //   return pages[props.note.pageId].value;
    // });

    const firstLink = computed(() => {
      console.log(page);
      if (!page || !page.value) {
        console.log(props.note);
      }
      const div = document.createElement('div');
      div.innerHTML = page.value.title;
      const a = div.querySelector('a');
      console.log(a);
      return a ? a.href : false;
    });

    const isImageUrl = computed(() => {
      return firstLink.value && firstLink.value.match(/\.(jpeg|jpg|gif|png)$/) != null;
    });

    const isQuote = computed(() => {
      return page.value.type == 13;
    });

    const isHidden = computed(() => {
      return page.value.type == 7;
    });

    const dialog = ref(false);

    return { page, firstLink, isImageUrl, isQuote, isHidden, dialog };
  }
};
</script>

<style>
.card-paragraph {
  line-height: 1.3em;
}

.card-content-image:hover {
  opacity: 0.8;
}
</style>
